import _regeneratorRuntime from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/add.svg';
import _imports_1 from '@/assets/image/no-more.svg';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3eda1fa1"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "main"
};
var _hoisted_2 = {
  class: "header"
};
var _hoisted_3 = {
  class: "header-left"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-zhushi"
  }, null, -1);
});
var _hoisted_7 = {
  style: {
    "margin-top": "22px",
    "width": "100%"
  }
};
var _hoisted_8 = {
  key: 0,
  class: "product-list"
};
var _hoisted_9 = {
  key: 1,
  class: "no-more"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var __default__ = {
  name: 'MyProduct'
};
import Product from '@/api/product';
import { $rdoLang } from '@/assets/common/common';
import { XlButton } from '@shining3d/ui-components';
import { VueCookieNext } from 'vue-cookie-next';
import { useLang } from '../../hooks/lang';
import OfflineActivation from '../offline-activation/index.vue';
import ProductItem from './components/product-item.vue';
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    var _useLang = useLang(),
      $t = _useLang.$t;
    var productList = ref([]);
    var loading = ref(false);
    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$Product$myProd, result, status;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return Product.myProductList({
                page: 1,
                pageSize: 20000,
                skipMaxPageSize: true,
                lang: $rdoLang(VueCookieNext.getCookie('lang'))
              });
            case 3:
              _yield$Product$myProd = _context.sent;
              result = _yield$Product$myProd.result;
              status = _yield$Product$myProd.status;
              if (status) {
                productList.value = result || [];
              }
              loading.value = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getList() {
        return _ref.apply(this, arguments);
      };
    }();
    var offlineDialog = ref(false);
    var openDialog = function openDialog() {
      offlineDialog.value = true;
    };
    onMounted(function () {
      getList();
    });
    return function (_ctx, _cache) {
      var _productList$value;
      var _component_el_tooltip = _resolveComponent("el-tooltip");
      var _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(XlButton), {
        onClick: openDialog,
        type: "primary",
        class: "no-radius"
      }, {
        default: _withCtx(function () {
          return [_hoisted_4, _createTextVNode(" " + _toDisplayString(_unref($t)("home.activate")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        effect: "dark",
        placement: "bottom",
        "popper-class": "popper"
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("div", {
            innerHTML: _unref($t)('product.tooltip')
          }, null, 8, _hoisted_5)];
        }),
        default: _withCtx(function () {
          return [_hoisted_6];
        }),
        _: 1
      })]), _createTextVNode(" " + _toDisplayString(_ctx.lang) + " ", 1), _createElementVNode("span", null, _toDisplayString(_unref($t)("product.total", {
        total: (_productList$value = productList.value) === null || _productList$value === void 0 ? void 0 : _productList$value.length
      })), 1)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [productList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, function (i, index) {
        return _openBlock(), _createBlock(ProductItem, {
          key: i.id,
          info: i,
          isEnd: index > productList.value.length - 2 && productList.value.length > 2,
          onRefresh: getList
        }, null, 8, ["info", "isEnd"]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(_unref($t)("product.noMore")), 1)]))])), [[_directive_loading, loading.value]]), _createVNode(OfflineActivation, {
        modelValue: offlineDialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return offlineDialog.value = $event;
        }),
        onSubmit: getList
      }, null, 8, ["modelValue"])]);
    };
  }
});